import React from "react"

import { useTranslation } from "react-i18next"

import { FreeSpinsSummary } from "services/bonus/type"

import { formatFiatCurrency } from "util/formatter"

interface FreeSpinsSummaryCardsProps {
  summary: FreeSpinsSummary
}

export const FreeSpinsSummaryCards: React.FC<FreeSpinsSummaryCardsProps> = ({ summary }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-[#1A1A2E] rounded-lg p-4 text-center">
        <div className="text-3xl font-bold text-purple-400">{summary.totalPlayers}</div>
        <div className="text-sm text-gray-400">{t("bonus2.spins.activePlayers")}</div>
      </div>
      <div className="bg-[#1A1A2E] rounded-lg p-4 text-center">
        <div className="text-3xl font-bold text-emerald-400">{summary.totalSpinsRemaining}</div>
        <div className="text-sm text-gray-400">{t("bonus2.spins.spinsRemaining")}</div>
      </div>
      <div className="bg-[#1A1A2E] rounded-lg p-4 text-center">
        <div className="text-3xl font-bold text-yellow-400">{formatFiatCurrency(summary.totalWinnings)}</div>
        <div className="text-sm text-gray-400">{t("bonus2.spins.totalWinnings")}</div>
      </div>
      <div className="bg-[#1A1A2E] rounded-lg p-4 text-center">
        <div className="text-3xl font-bold text-rose-400">{summary.expiringToday}</div>
        <div className="text-sm text-gray-400">{t("bonus2.spins.expiringToday")}</div>
      </div>
    </div>
  )
}
